import React, {useState} from 'react'
import UnderLineInput from '../../components/input/UnderLineInput'
import Text from '../../components/text/Text'
import WizImage from '../../components/image/WizImage'
import WizButton from '../../components/button/WizButton'
import {postLoginApi} from '../../apis/login/login'
import useNavigation from '../../hooks/useNavigation'
import {getUserList} from '../../apis/user/getUserList'
import {getPingApi} from '../../apis/ping/ping'

interface IProps {
    className?: string
    setIsLogin?: (e: boolean) => void
}

const LoginPage: React.FC<IProps> = ({className, setIsLogin}) => {
    const [userEmail, setUserEmail] = useState('')
    const [userPassword, setUserPassword] = useState('')
    const {goMain} = useNavigation()

    const loginFunc = async () => {
        const data = await postLoginApi(userEmail, userPassword)

        if (data?.data?.success) {
            localStorage.setItem('wiz-admin-userId', data.data.user_id)
            localStorage.setItem('wiz-admin-userToken', data.data.access_token)

            const isAuthCheck = await getUserList()

            if (
                isAuthCheck?.code === 404 ||
                isAuthCheck?.Message === 'unauthorized' ||
                isAuthCheck?.isManager === false ||
                !isAuthCheck?.data ||
                data?.error
            ) {
                alert('접근 권한이 없습니다. 관련 담당자에게 권한 요청을 부탁드립니다.')
                localStorage.removeItem('wiz-admin-userId')
                localStorage.removeItem('wiz-admin-userToken')
            } else {
                setIsLogin(true)
                goMain()
            }
        } else {
            alert(data?.error)
        }
    }

    return (
        <div className={'flex items-center min-h-screen'}>
            <div className={'w-[500px] p-[60px] bg-white rounded-[10px] shadow-normal mx-auto'}>
                <div className={'space-y-[20px]'}>
                    <WizImage src={'/lot/logo.png'} className={'w-[60px] mx-auto'} />
                    <Text className={'text-center text-h2'}>Management League of Traders</Text>
                </div>
                <div className={'mt-[60px] space-y-[20px]'}>
                    <div className={'space-y-[5px]'}>
                        <Text className={'text-body2 text-font02'}>Email</Text>
                        <UnderLineInput type={'text'} onChanged={setUserEmail} id={'userEmail'} />
                    </div>
                    <div className={'space-y-[5px]'}>
                        <Text className={'text-body2 text-font02'}>Password</Text>
                        <UnderLineInput
                            type={'password'}
                            onChanged={setUserPassword}
                            onEnterKeyPress={() => loginFunc()}
                            id={'userPassword'}
                        />
                    </div>
                </div>
                <div className={'mt-[30px]'}>
                    <WizButton text={'Log In'} onClick={() => loginFunc()} className={'w-full'} />
                </div>
            </div>
        </div>
    )
}

export default LoginPage
